export class DialogModelConfirm {
    constructor(
      public topic: string,
      public invoiceNumber: string,
      public key: any,
      public dialogType: string
    ) {}
  }
  